import React from "react";
import Logo from "../../assets/images/SVG/humano_logo_primary.svg";

const Header = () => {
  return (
    // <!--Header Section Starts Here-->
    <header className="bg-white flex flex-row">
      <div className="flex justify-between">
        <div className="p-1 mx-5 inline-flex">
          <img src={Logo} alt="Logo" className="h-20 w-40" />
        </div>
      </div>
    </header>
  );
};

export default Header;
